/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Resquest to update period of timeslots
 * @export
 * @interface TimeslotUpdatePeriodRequest
 */
export interface TimeslotUpdatePeriodRequest {
    /**
     * new start date
     * @type {string}
     * @memberof TimeslotUpdatePeriodRequest
     */
    startDate?: string;
    /**
     * new end date
     * @type {string}
     * @memberof TimeslotUpdatePeriodRequest
     */
    endDate?: string;
}

/**
 * Check if a given object implements the TimeslotUpdatePeriodRequest interface.
 */
export function instanceOfTimeslotUpdatePeriodRequest(value: object): value is TimeslotUpdatePeriodRequest {
    return true;
}

export function TimeslotUpdatePeriodRequestFromJSON(json: any): TimeslotUpdatePeriodRequest {
    return TimeslotUpdatePeriodRequestFromJSONTyped(json, false);
}

export function TimeslotUpdatePeriodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotUpdatePeriodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
    };
}

export function TimeslotUpdatePeriodRequestToJSON(json: any): TimeslotUpdatePeriodRequest {
    return TimeslotUpdatePeriodRequestToJSONTyped(json, false);
}

export function TimeslotUpdatePeriodRequestToJSONTyped(value?: TimeslotUpdatePeriodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

